<div class="flex min-w-0 flex-auto flex-col">
  <!-- Header -->
  <div class="bg-card">
    <div class="mx-auto flex w-full max-w-screen-xl flex-col px-6 sm:px-8">
      <div
        class="my-8 flex min-w-0 flex-auto flex-col sm:my-12 sm:flex-row sm:items-center">
        <!-- Avatar and name -->
        <div class="flex min-w-0 flex-auto items-center">
          <div class="h-16 w-16 flex-0 overflow-hidden rounded-full">
            <img
              class="h-full w-full object-cover"
              src="images/avatars/brian-hughes.jpg" />
          </div>
          <div class="ml-4 flex min-w-0 flex-col">
            <ng-container *transloco="let t">
              <div
                class="truncate text-2xl font-semibold leading-7 tracking-tight md:text-5xl md:leading-snug">
                {{ 'WelcomeBack' | transloco }} {{authService.user?.Name}}
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <!-- Project selector -->
      <div
        class="bg-default relative flex cursor-pointer self-start overflow-hidden rounded-t-xl border border-b-0 pb-1 pl-5 pr-4 pt-2"
        matRipple>
        <div class="flex items-center">
          <div class="overflow-hidden">
            <div class="truncate font-medium leading-6">
              {{'AccountingOverview' | transloco}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Main -->
  <div class="-mt-px flex-auto border-t pt-4 sm:pt-6">
    <div class="mx-auto w-full max-w-screen-xl">
      <!-- Tabs -->
      <mat-tab-group
        class="sm:px-2"
        mat-stretch-tabs="false"
        [animationDuration]="'0'"
        [(selectedIndex)]="selectedTabIndex">
        <!-- Summary -->
        <mat-tab label="Summary">
          <ng-template matTabContent>

            @if(data()?.yearlySummary) {
            <app-total-revenue
              [data]="data().yearlySummary"
              [year]="setYear"></app-total-revenue>
            }

            <div
              class="grid w-full min-w-0 mt-6 grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-4">
              <!-- Summary -->
              <div
                class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl p-6 shadow">
                <div class="flex items-start justify-between">
                  <div
                    class="truncate text-lg font-medium leading-6 tracking-tight">
                    {{'CompletelyPaid' | transloco}}
                  </div>
                  <!-- <div class="-mr-3 -mt-2 ml-2">
                    <button
                      mat-icon-button
                      [matMenuTriggerFor]="summaryMenu">
                      <mat-icon
                        class="icon-size-5"
                        [svgIcon]="
                                                    'heroicons_mini:ellipsis-vertical'
                                                "></mat-icon>
                    </button>
                    <mat-menu #summaryMenu="matMenu">
                      <button mat-menu-item>
                        Yesterday
                      </button>
                      <button mat-menu-item>
                        2 days ago
                      </button>
                      <button mat-menu-item>
                        3 days ago
                      </button>
                    </mat-menu>
                  </div> -->
                </div>
                <div class="mt-2 flex flex-col items-center">
                  <div
                    class="text-7xl font-bold leading-none tracking-tight text-green-500 sm:text-8xl">
                    {{data().completelyPaid}}
                  </div>
                  <div
                    class="text-lg font-medium text-green-600 dark:text-green-500">
                    {{data().completelyPaidSum | currency: 'CHF'}}
                  </div>
                </div>
              </div>
              <!-- Overdue -->
              <div
                class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl p-6 shadow">
                <div class="flex items-start justify-between">
                  <div
                    class="truncate text-lg font-medium leading-6 tracking-tight">
                    {{'PartiallyPaid' | transloco}}
                  </div>
                  <!-- <div class="-mr-3 -mt-2 ml-2">
                    <button
                      mat-icon-button
                      [matMenuTriggerFor]="overdueMenu">
                      <mat-icon
                        class="icon-size-5"
                        [svgIcon]="
                                                    'heroicons_mini:ellipsis-vertical'
                                                "></mat-icon>
                    </button>
                    <mat-menu #overdueMenu="matMenu">
                      <button mat-menu-item>
                        Yesterday
                      </button>
                      <button mat-menu-item>
                        2 days ago
                      </button>
                      <button mat-menu-item>
                        3 days ago
                      </button>
                    </mat-menu>
                  </div> -->
                </div>
                <div class="mt-2 flex flex-col items-center">
                  <div
                    class="text-7xl font-bold leading-none tracking-tight text-amber-500 sm:text-8xl">
                    {{data().partiallyPaid}}
                  </div>
                  <div
                    class="text-lg font-medium text-amber-600 dark:text-amber-500">
                    {{data().partiallyPaidSum | currency: 'CHF'}}
                  </div>
                </div>
              </div>
              <!-- Issues -->
              <div
                class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl p-6 shadow">
                <div class="flex items-start justify-between">
                  <div
                    class="truncate text-lg font-medium leading-6 tracking-tight">
                    {{'Unpaid' | transloco}}
                  </div>
                  <!-- <div class="-mr-3 -mt-2 ml-2">
                    <button
                      mat-icon-button
                      [matMenuTriggerFor]="issuesMenu">
                      <mat-icon
                        class="icon-size-5"
                        [svgIcon]="
                                                    'heroicons_mini:ellipsis-vertical'
                                                "></mat-icon>
                    </button>
                    <mat-menu #issuesMenu="matMenu">
                      <button mat-menu-item>
                        Yesterday
                      </button>
                      <button mat-menu-item>
                        2 days ago
                      </button>
                      <button mat-menu-item>
                        3 days ago
                      </button>
                    </mat-menu>
                  </div> -->
                </div>
                <div class="mt-2 flex flex-col items-center">
                  <div
                    class="text-7xl font-bold leading-none tracking-tight text-red-500 sm:text-8xl">
                    {{data().unpaid}}
                  </div>
                  <div
                    class="text-lg font-medium text-red-600 dark:text-red-500">
                    {{data().unpaidSum | currency: 'CHF'}}
                  </div>
                </div>
              </div>
              <!-- Features -->
              <div
                class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl p-6 shadow">
                <div class="flex items-start justify-between">
                  <div
                    class="truncate text-lg font-medium leading-6 tracking-tight">
                    Abacus
                  </div>
                  <!-- <div class="-mr-3 -mt-2 ml-2">
                    <button
                      mat-icon-button
                      [matMenuTriggerFor]="featuresMenu">
                      <mat-icon
                        class="icon-size-5"
                        [svgIcon]="
                                                    'heroicons_mini:ellipsis-vertical'
                                                "></mat-icon>
                    </button>
                    <mat-menu #featuresMenu="matMenu">
                      <button mat-menu-item>
                        Yesterday
                      </button>
                      <button mat-menu-item>
                        2 days ago
                      </button>
                      <button mat-menu-item>
                        3 days ago
                      </button>
                    </mat-menu>
                  </div> -->
                </div>
                <div class="mt-2 flex flex-col items-center">
                  <div
                    class="text-7xl font-bold leading-none tracking-tight text-blue-500 sm:text-8xl">
                    {{data().isAbacus}}
                  </div>
                  <div
                    class="text-lg font-medium text-blue-600 dark:text-blue-500">
                    {{data().isAbacusSum | currency: 'CHF'}}
                  </div>
                </div>
              </div>
            </div>

            @if(data()?.vehicleStock) {
            <app-vehicle-stock [data]="data().vehicleStock"
              [range]="range"></app-vehicle-stock>
            }

            @if(data()?.payments) {
            <app-payments-overview [payments]="data().payments"
              [previousYearPayments]="data().previousYearPayments" [year]="setPaymentYear"></app-payments-overview>
            }
          </ng-template>
        </mat-tab>

      </mat-tab-group>
    </div>
  </div>
</div>
